import dateformat from 'dateformat';

export function formatDate(date: Date) {
  return dateformat(date, 'yyyy年m月d日 HH:MM:ss');
}
